import { ImageBackground, View, type ViewStyle } from 'react-native'

export function FrozenCard({
  style,
  imageBackgroundStyle,
}: {
  style?: ViewStyle
  imageBackgroundStyle?: ViewStyle
}) {
  return (
    <View style={style}>
      <ImageBackground
        style={imageBackgroundStyle}
        source={require('@/src/assets/images/frozen_card.png')}
        resizeMode="cover"
        resizeMethod="scale"
      />
    </View>
  )
}
